module.exports = __webpack_public_path__ + "img/raisehand.2a3b915f.svg";